import React from 'react';
import styles from './LogoHeader.module.scss';
import Logo from '../../assets/CC_Education_Logo_RGB.jpg';
import { Container, Row, Col } from 'react-bootstrap';

const LogoHeader = () => (
  <Container className={styles.LogoHeader} data-testid="LogoHeader">
    <Row>
      <Col>
        <img
          loading="lazy"
          alt="Cross Country Healthcare"
          className="formLogoImg"
          src={Logo}
          height="48"
          width="150"
        ></img>
      </Col>
    </Row>
  </Container>
);

export default LogoHeader;
